import FormText from 'components/form/FormText';
import FormWysiwygEditor from 'components/form/FormWysiwygEditor';
import { useFormContext } from 'react-hook-form';
import type { VoiceChatEditFormStateType } from 'types/page/voiceChatEditFormStateType';

import type { JSX } from 'react';

/**
 * ボイスチャット作成編集 完了ページ設定コンポーネント（モック 941-989 行相当）。
 * DB は d_voice_chat_result（form 同型）だが完了ページは単一のためフィールド配列を持たない。
 */
export default function WsVoiceChatEditComplete(props: { readOnly: boolean }): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<VoiceChatEditFormStateType>();

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <section className="section-form-default">
      <div className="container">
        <div className="box-common">
          <h3 className="title-section title-md">完了ページ設定</h3>
          <div className="form-default-container">
            <div className="row row-0">
              <div className="col-md col-form">
                <div className="form-group mb-md-4">
                  <FormText
                    subject="タイトル"
                    name="completeTitle"
                    placeholder="タイトルを入れよう"
                    register={register}
                    errors={errors}
                    readOnly={props.readOnly}
                  />
                </div>
                <div className="form-group">
                  <FormWysiwygEditor
                    control={control}
                    subject="音声完了後の説明やフィードバック"
                    name="completeDescriptionHtml"
                    placeholder="すべての回答を終えたユーザーに向けた説明文を入れましょう。画像やリンクなども貼り付けることができます。"
                    toolbar={['highlight', 'link', 'image', 'button']}
                    errors={errors}
                    readOnly={props.readOnly}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
